import React from 'react';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { SkeletonText, SkeletonThumbnail } from '@shared/components/Skeleton';
import { TILE_THUMBNAIL_WIDTH, TILE_BORDER_RADIUS } from '@shared/components/HotelTile';

const BOOKING_TILE_HEIGHT = 204;
const BOOKING_SKELETON_COUNT = 3;

export const GuestBookingTileSkeleton: React.FC = React.memo(() => (
  <Flex
    alignItems="stretch"
    width="100%"
    border="1px solid"
    borderColor="mono3"
    borderRadius={pxToRem(TILE_BORDER_RADIUS)}
    minHeight={pxToRem(BOOKING_TILE_HEIGHT)}
  >
    <SkeletonThumbnail
      overrides={{
        PlaceholderRoot: {
          props: {
            width: pxToRem(TILE_THUMBNAIL_WIDTH),
            minWidth: pxToRem(TILE_THUMBNAIL_WIDTH),
            alignSelf: 'stretch',
            borderTopLeftRadius: pxToRem(TILE_BORDER_RADIUS),
            borderBottomLeftRadius: pxToRem(TILE_BORDER_RADIUS),
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
        },
      }}
    />
    <Flex
      flex={1}
      flexDirection="column"
      gap={1}
      minWidth={0}
      paddingY={3}
      paddingX={4}
    >
      {/* Hotel name + metadata */}
      <SkeletonText
        rows={1}
        width="75%"
        skeletonHeight={pxToRem(20)}
      />
      <SkeletonText
        rows={1}
        width="45%"
        skeletonHeight={pxToRem(16)}
      />
      {/* Guest name + email */}
      <Flex
        flexDirection="column"
        gap={1}
        marginTop={2}
      >
        <SkeletonText
          rows={1}
          width="55%"
          skeletonHeight={pxToRem(18)}
        />
        <SkeletonText
          rows={1}
          width="65%"
          skeletonHeight={pxToRem(16)}
        />
      </Flex>
      {/* Date range + occupancy */}
      <SkeletonText
        rows={1}
        width="60%"
        skeletonHeight={pxToRem(16)}
      />
      {/* Bottom tag */}
      <SkeletonText
        rows={1}
        width="40%"
        skeletonHeight={pxToRem(16)}
      />
    </Flex>
  </Flex>
));

GuestBookingTileSkeleton.displayName = 'GuestBookingTileSkeleton';

export const GuestBookingTileSkeletonList: React.FC = React.memo(() => (
  <Flex
    flexDirection="column"
    gap={7}
  >
    {Array.from({ length: BOOKING_SKELETON_COUNT }).map((_, i) => (
      <GuestBookingTileSkeleton key={i} />
    ))}
  </Flex>
));

GuestBookingTileSkeletonList.displayName = 'GuestBookingTileSkeletonList';
